<template>
  <div class="contents-container">
    <div class="content">
      <h2 class="data-title">text message</h2>

      <div v-if="hasNotificationImgMeta && hasNotificationImage" class="notification-image-container">
        <h4>notification image</h4>
        <div class="image-attachment">
          <img class="thumbnail"
            :src="thumbImage"
            @click="setPreviewModal(thumbImage)">
        </div>
      </div>

      <div class="content-text">{{ messageDetails.template_content }}</div>
    </div>

    <div class="content">
      <h2 class="data-title">stashboard content</h2>

      <div v-if="hasImageAttachments" class="attachment-container">
        <h4>mms (as {{ messageDetails.image_type }})</h4>
        <div v-for="(mms, index) in messageDetails.mms"
             class="image-attachment"
             :key="index">
          <img class="thumbnail"
            :src="mms"
            @click="setPreviewModal(mms)">
        </div>
      </div>

      <div class="content-text">{{ messageDetails.sms_content }}</div>
    </div>

    <modal
      v-if="showModal"
      @close="closeModal"
      :showActionButton="false"
      showClose
      wrapperClasses="image-preview-modal">
      <template #body>
        <image-preview :previewUrl="modalConfig.imageUrl" />
      </template>
    </modal>
  </div>
</template>

<script>
import ImagePreview from '../Shared/ImagePreview.vue'
import Modal from '../Shared/Modal.vue'

export default {
  props: {
    hasNotificationImgMeta: Boolean,
    messageDetails: Object
  },

  name: 'Contents',

  components: {
    ImagePreview,
    Modal
  },

  data() {
    return {
      showModal: false,
      modalConfig: null
    }
  },

  computed: {
    hasImageAttachments() {
      return this.messageDetails.mms?.length > 0
    },
    hasNotificationImage() {
      return !!this.messageDetails.template_image
    },
    thumbImage() {
      return this.messageDetails.template_image?.attachment?.thumb
    }
  },

  methods: {
    closeModal() {
      this.showModal = false
    },

    setPreviewModal(imageUrl) {
      this.showModal = true
      this.modalConfig = { imageUrl }
    }
  }
}
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.contents-container
  .content
    h2
      text-align: left
    .content-text
      background-color: $tertiary-color
      border-radius: 8px
      color: white
      font-family: monospace, monospace
      line-height: 1.5
      margin: 0 0 1rem 0
      padding: 1rem
      text-align: left
      white-space: pre-line
      word-wrap: break-word
    .attachment-container, .notification-image-container
      text-align: left
      .thumbnail
        margin: 5px auto
        border: none
        box-shadow: none
        height: 50px
        cursor: pointer
  .image-preview-modal .modal
    max-width: 850px
</style>